import * as React from "react";

import ReactSignatureCanvas from "react-signature-canvas";
import { PDFDocument, rgb } from "pdf-lib";
import { convertUSDateToEUWithTimeDate } from "../../../../util/DateHelper";
import "./style.css";
import { PrimaryButton } from "@fluentui/react";
import api from "../../../../api";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../state";
import { updateOrder } from "../../../../state/order/action";

interface Props {
    order: Order;
}

const PDFPATH = "/ADAS Disclaimer.pdf";

const SignPdf: React.FunctionComponent<Props> = props => {
  
    const signatureCanvas = React.useRef(null);
    const dispatch = useDispatch<AppDispatch>();
    
   
    const handleSignPdf = async () => {
        const existingPdfBytes = await fetch(PDFPATH).then(res =>
            res.arrayBuffer()
        );

        const pdfDoc = await PDFDocument.load(existingPdfBytes);
        const pages = pdfDoc.getPages();
        const firstPage = pages[0];
        const signatureDataUrl = (signatureCanvas as any).current.getTrimmedCanvas().toDataURL("image/png");
        const signatureImageBytes = await fetch(signatureDataUrl).then(res =>
            res.arrayBuffer()
        );
        const signatureImage = await pdfDoc.embedPng(signatureImageBytes);

        const signatureDims = signatureImage.scale(0.5);
        let baseY = 100;
        const lineHeight = 49;
        // add signature to the pdf
        firstPage.drawImage(signatureImage, { x: 130, y: baseY, width: signatureDims.width, height: signatureDims.height });
       
        baseY += lineHeight;
        const basedrawText = { size: 20, color: rgb(0, 0, 0)};
        // add date to the pdf
        firstPage.drawText(convertUSDateToEUWithTimeDate(new Date()), { ...basedrawText, x: 90, y: baseY });
        baseY += 45;
        if (props.order.car.registrationNumber) {
            // add car registration number to the pdf
            firstPage.drawText(props.order.car.registrationNumber, {...basedrawText, x: 155, y: baseY });
        }
        baseY += 45;
        // add customer email to the pdf
        firstPage.drawText(props.order.customer.email, {...basedrawText, x: 135, y: baseY });

        if(props.order.additionalData.orderId)
        {
            const pdfBytes = await pdfDoc.save();
            // pdf-lib returns an ArrayBuffer-backed array, which the Blob typings cannot infer
            const blob = new Blob([pdfBytes as Uint8Array<ArrayBuffer>], { type: "application/pdf" });
            const url = await api.OrderAPI.SignCalibrationChallenges(props.order.additionalData.orderId, blob);
            dispatch(updateOrder({...props.order, orderProperties: {...props.order.orderProperties, signCalibrationChallenges: url}}));
        }
    };

    return (
        <div>
            <p>PDF: <a target="_blank" href={PDFPATH}>PDF</a></p>
            <p>Underskriv Disclaimer: </p>
            <ReactSignatureCanvas
                clearOnResize={true}
                ref={signatureCanvas}
                penColor="black"
                canvasProps={{  width: 450, height: 85, className: "sigCanvas" }}
            />
            <PrimaryButton onClick={handleSignPdf} text="Underskriv" />
            {props.order.orderProperties && props.order.orderProperties.signCalibrationChallenges && (
                <a href={props.order.orderProperties.signCalibrationChallenges} download="signed-document.pdf">
                   Se Underskrevet PDF
                </a>
            )}
        </div>
    );
};

export default SignPdf;